import { FetchData } from "services/api";

export const fetchClients = (params = {}, signal) => {
  const searchParams = new URLSearchParams();
  if (params.limit) searchParams.set("limit", params.limit);
  if (params.offset !== undefined) searchParams.set("offset", params.offset);
  if (params.status && params.status !== "All") {
    searchParams.set("status", params.status);
  }
  if (params.search && params.search.trim() !== "") {
    searchParams.set("search", params.search.trim());
  }
  if (params.sortField) {
    searchParams.set("sortField", params.sortField);
  }
  if (params.sortDirection) {
    searchParams.set("sortDirection", params.sortDirection);
  }
  const query = searchParams.toString();
  return FetchData(`/api/client${query ? `?${query}` : ""}`, {
    method: "GET",
    signal,
  });
};

export const fetchClientById = (clientId) =>
  FetchData(`/api/client/${clientId}`, {
    method: "GET",
  });

export const deleteClientsByIds = (clientIds) =>
  FetchData(`/api/client/${clientIds}`, {
    method: "DELETE",
  });

export const changeClientsStatusByIds = (clientIds) =>
  FetchData(`/api/client/status/${clientIds}`, {
    method: "PUT",
  });

export const fetchClientBranches = (clientId) =>
  FetchData(`/api/client/branch/client/${clientId}`, {
    method: "GET",
  });

export const fetchBranchContacts = (branchId) =>
  FetchData(`/api/client/contact/branch/${branchId}`, {
    method: "GET",
  });

export const fetchClientContactById = (contactId) =>
  FetchData(`/api/client/contact/${contactId}`, {
    method: "GET",
  });

export const createClientContact = (payload) =>
  FetchData("/api/contact", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const createClient = (payload) =>
  FetchData("/api/client", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateClient = (clientId, payload) =>
  FetchData(`/api/client/${clientId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const sendClientInvoices = (orderIds, type) =>
  FetchData("/api/client/invoice", {
    method: "POST",
    body: JSON.stringify({
      order_id: orderIds,
      type,
    }),
  });
